import { useFeatureAccess } from "../../access-control/hooks/useFeatureAccess";
import { FEATURE_KEYS } from "../../access-control/models/role-feature.models";
import { ToastContainer } from "../../shared/components/ToastContainer";
import AdminPaintSchemePanel from "../components/paint-scheme/AdminPaintSchemePanel";
import { ADMIN_PATHS } from "../models/admin.models";
import { Navigate } from "react-router-dom";

const AdminPaintSchemesPage = () => {
  const { hasFeature } = useFeatureAccess();

  if (!hasFeature(FEATURE_KEYS.ADMIN_REF_PARAMETERS_PAINT_SCHEMES)) {
    return <Navigate to={ADMIN_PATHS.root} replace />;
  }

  return (
    <>
      <ToastContainer />
      <AdminPaintSchemePanel />
    </>
  );
};

export default AdminPaintSchemesPage;
